import { render } from "./new.vue?vue&type=template&id=e6f33522&scoped=true"
import script from "./new.vue?vue&type=script&lang=js"
export * from "./new.vue?vue&type=script&lang=js"

import "./new.vue?vue&type=style&index=0&id=e6f33522&lang=scss&scoped=true"
import "./new.vue?vue&type=style&index=1&id=e6f33522&lang=scss"

import exportComponent from "/data/jenkins/workspace/talk-community-h5-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e6f33522"]])

export default __exports__